import React, { useEffect, useState } from "react";
import AHeader from "../component/AHeader";
import AFooter from "../component/AFooter";
import axios from "axios";
import { toast } from "react-toastify";
import { redirect  } from "react-router-dom";

function Add_categories() {

  const [cate_name, setcate_name] = useState('');
  const [cate_img, setcate_img] = useState('');

  function validation() {
    var ans = true;
    if (cate_name == "") {
      toast.error("cate_name Field is required");
      ans = false;
      return false;
    }
    if (cate_img == "") {
      toast.error(" cate_img Field is required");
      ans = false;
      return false;
    }
    return ans;
  }

  const submithandle = async (i) => {
    i.preventDefault();
    if (validation()) {
      const formData = new FormData();
      formData.append('id', new Date().getTime().toString());
      formData.append('cate_name', cate_name);
      formData.append('cate_img', cate_img);

      const res = await axios.post(
        `https://www.rajvicosmeticclinic.com/RajviApi/categories_post`,
        formData, {
        headers: { 'Content-Type': "multipart/form-data" }
      });
      if (res.status == 200) {
        toast.success(res.data.message); 
      }
      redirect('/add_categories');
    }
  };

  return (
    <div>
      <AHeader title="Add Categories" />
      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="bg-light  p-lg-5 ">
                <h6 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">
                  Categories
                </h6>
                <h1 className="mb-4">Add Categories</h1>

                <form
                  action=""
                  role="form"
                  method="post"
                  onSubmit={submithandle}
                  id="contactForm" enctype="multipart/form-data">
                  <div className="form-row">
                    <div className="col-sm-12 control-group">
                      <input
                        type="text"
                        className="form-control border-0 p-4"
                        onChange={(e) => setcate_name(e.target.value)}
                        id="name"
                        placeholder="Categories Name"
                      />
                      <p className="help-block text-danger" />
                    </div>
                    <div className="col-sm-12 control-group">
                      <input
                        type="file"
                        onChange={(e) => setcate_img(e.target.files[0])}
                        className="form-control border-0"
                        id="cate_img"
                        placeholder="Categories Image" />
                      <p className="help-block text-danger" />
                    </div>
                  </div>
                  <div>
                    <button
                      className="btn btn-primary py-3 px-4"
                      type="submit"
                      id="sendMessageButton"
                    >
                      Add
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AFooter />
    </div>
  );
}

export default Add_categories;
